import { useMutation } from '@tanstack/react-query'
import { useCurrentUser, useAccessToken } from '@/features/auth/state/auth'

import api from '@/lib/api'
export function useDeletedAnexoCreditByID() {
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async (id: string) => {
      if (!user || !token) throw new Error('Usuário ou token ausente')

      const response = await api.post(`/anexos/Deleted/${id}`)

      if (response.data) {
        return response.data
      } else {
        throw new Error('Estrutura de resposta inesperada')
      }
    }
  })
}
